var map = {
	"./en/1-1/yq.png": 66806,
	"./fi/1-1/yq.png": 12120,
	"./in/1-1/yq.png": 43917,
	"./th/1-1/yq.png": 25189,
	"./tw/1-1/yq.png": 77828,
	"./zh/1-1/yq.png": 4711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28374;